

export const Porcentaje = () => {
  return (
    <>
      <div className="alert alert-warning d-block d-sm-none text-center">
        Está página se ve mejor en dispositivos con mayor resolución horizontal 
      </div>
      <div className="mb-2 text-end">
        <p className="border-bottom"><i className="las la-download"></i>Descarga los porcentajes en: 
          <a href="https://iepac.mx/porcentaje-minimo-de-participacion-ciudadana.xlsx" rel="noreferrer" target="_blank">
            <i className="las la-file-excel la-2x text-success"></i> 
          </a> o &nbsp;  
          <a href="https://iepac.mx/porcentaje-minimo-de-participacion-ciudadana.pdf" rel="noreferrer" target="_blank">
            <i className="las la-file-pdf la-2x"></i> 
          </a>
        </p>
      </div>
      <iframe title="iepac" src="https://iepac.mx/porcentaje-minimo-de-participacion-ciudadana"  style={{ width: "100%", height:"950px" }}></iframe>
    </>
  )
}
